import React from 'react';
import ReactDOM from 'react-dom';
import './assets/styles/index.css';
import './assets/styles/reset.css';
import App from './App';

import './i18n';

const element = <App />;
ReactDOM.render(element, document.getElementById('root'));
